import React from 'react';
import { VideoEmbed } from './clientUtils';
import { accentTones } from './designTokens';

// T-16 K3: neutral info-ruta (krockar inte med klinikens färg), status för Obs/Bra att veta.
const TONE_STYLES = {
  info:    { bg: '#F1F3F6', text: '#3F4756', label: 'Info' },
  warning: { bg: '#FEF3C7', text: '#92400E', label: 'Obs!' },
  success: { bg: '#DCFCE7', text: '#166534', label: 'Bra att veta' },
};

function VideoBlock({ block }) {
  if (!block.video_url) return null;
  return (
    <div style={{ marginTop: '12px' }}>
      <VideoEmbed url={block.video_url} />
      {block.video_label && (
        <p style={{ margin: '6px 0 0', fontSize: '0.83em', color: '#6B728E' }}>{block.video_label}</p>
      )}
    </div>
  );
}

function StepBlock({ block, stepNumber, brandAccent }) {
  return (
    <div style={{ marginTop: '12px', borderLeft: `3px solid ${brandAccent}`, paddingLeft: '12px' }}>
      <span style={{ color: accentTones(brandAccent).text, fontWeight: '700', fontSize: '0.78em', letterSpacing: '0.02em' }}>
        Steg {stepNumber}
      </span>
      {block.title && (
        <p style={{ margin: '4px 0 0', fontWeight: '600', fontSize: '0.9em', color: '#1D2540', lineHeight: '1.4' }}>
          {block.title}
        </p>
      )}
      {block.body && (
        <p style={{ margin: '4px 0 0', fontSize: '0.875em', color: '#6B728E', lineHeight: '1.55' }}>
          {block.body}
        </p>
      )}
      {block.images?.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
          {block.images.map(img => (
            <img
              key={img.id}
              src={img.url}
              alt={img.alt || ''}
              style={{ width: 'calc(50% - 4px)', borderRadius: '7px', objectFit: 'cover', maxHeight: '180px' }}
              onError={e => { e.currentTarget.style.display = 'none'; }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

function GalleryBlock({ block }) {
  const images = block.images || [];
  if (images.length === 0) return null;
  return (
    <div style={{ marginTop: '12px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
      {images.map(img => (
        <img
          key={img.id}
          src={img.url}
          alt={img.alt || ''}
          style={{ width: 'calc(50% - 4px)', borderRadius: '8px', objectFit: 'cover', maxHeight: '200px' }}
          onError={e => { e.currentTarget.style.display = 'none'; }}
        />
      ))}
    </div>
  );
}

function TipBlock({ block }) {
  const tone = TONE_STYLES[block.tone] || TONE_STYLES.info;
  return (
    <div style={{ marginTop: '12px', background: tone.bg, borderRadius: '8px', padding: '12px 14px' }}>
      <span style={{ fontWeight: '700', fontSize: '0.82em', color: tone.text }}>{tone.label}</span>
      {block.body && (
        <p style={{ margin: '4px 0 0', color: tone.text, fontSize: '0.875em', lineHeight: '1.5' }}>
          {block.body}
        </p>
      )}
    </div>
  );
}

export default function ExerciseBlocksRenderer({ blocks, brandAccent }) {
  if (!blocks?.length) return null;

  const sorted = [...blocks].sort((a, b) => a.order - b.order);
  let stepCounter = 0;

  return (
    <div style={{ marginTop: '10px' }}>
      {sorted.map(block => {
        switch (block.type) {
          case 'video':
            return <VideoBlock key={block.id} block={block} />;
          case 'step':
            stepCounter += 1;
            return <StepBlock key={block.id} block={block} stepNumber={stepCounter} brandAccent={brandAccent} />;
          case 'gallery':
            return <GalleryBlock key={block.id} block={block} />;
          case 'tip':
            return <TipBlock key={block.id} block={block} />;
          default:
            return (
              <div key={block.id || block.order} style={{ marginTop: '10px', color: '#9BA3BC', fontSize: '0.82em', fontStyle: 'italic' }}>
                (okänd blocktyp: {block.type})
              </div>
            );
        }
      })}
    </div>
  );
}
